module.exports = __webpack_public_path__ + "img/kiosk-standing.54d337a5.svg";